import { useResponsiveValue } from 'braid-design-system';
import type { Breakpoint } from 'braid-design-system/css';

const useBreakpoint = () => {
  const responsiveValue = useResponsiveValue();
  const currentBreakpoint = responsiveValue<Breakpoint>({
    mobile: 'mobile',
    desktop: 'desktop',
    tablet: 'tablet',
    wide: 'wide',
  });

  return currentBreakpoint;
};

export const useIsMobileOrTablet = () => {
  const breakpoint = useBreakpoint();
  return breakpoint === 'tablet' || breakpoint === 'mobile';
};
